














import { i18n } from '@/i18n';
import { MerchantInfo, MerchantState } from '@tencent/wphk-components-wecoupon';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import CounponButton from '@/components/we-coupons/coupon-button.vue';
import MerchantItemInfo from '@/components/we-coupons/merchant-item-info.vue';

@Component({
  components: {
    CounponButton,
    MerchantItemInfo,
  },
})
export default class WeCouponsMerchantItem extends Vue {
  @Prop() public data!: MerchantInfo;

  get avaliable() {
    return this.data.state === MerchantState.Normal;
  }

  get buttonText() {
    return this.avaliable ? i18n('领取') : i18n('查看');
  }

  @Emit('onCounpon')
  onCounpon() {}
}
